import { Box, Card, Group, Stack, Text, Title, UnstyledButton } from '@mantine/core'
import { IconAt, IconMapPin, IconPhone } from '@tabler/icons-react'
import { TwContainer } from '@/lib/components/TwContainer'

export const Locations = ({ subtitle, title }: { title?: string; subtitle?: string }) => {
	return (
		<section id={'locations'}>
			<TwContainer className={'justify-center py-24 gap-4 md:px-10'} column>
				{subtitle !== '' && (
					<Title ta={'center'} variant={'cyan'} fz={18}>
						{subtitle || 'Visit Us'}
					</Title>
				)}
				<Title variant={'title'} mb={'xl'}>
					{title || 'Our Locations'}
				</Title>
				<Box className={'grid md:grid-cols-2 gap-x-12 gap-y-16'} mt={'lg'}>
					<Card className={'shadow-2xl md:p-12 p-8'} radius={'lg'}>
						<Stack gap={'sm'}>
							<Stack gap={'sm'}>
								<Title fz={16} ta={'center'}>
									Fort Lauderdale
								</Title>
								<Text variant={'gray'}>
									<IconMapPin /> 906 W Sunrise Blvd Suite A,
									<br /> Fort Lauderdale, FL 33311
								</Text>
								<UnstyledButton c={'gray.6'} mx={'auto'} component={'a'} className={'flex items-center gap-2'} href={'tel:+1 844-650-2626'}>
									<IconPhone /> 844-650-2626
								</UnstyledButton>
								<UnstyledButton
									className={'flex items-center gap-2'}
									c={'gray.6'}
									mx={'auto'}
									component={'a'}
									href={'mailto:office@wellviewcare.org'}
								>
									<IconAt /> office@wellviewcare.org
								</UnstyledButton>
							</Stack>
							<Stack gap={0} align={'center'}>
								<Title mt={'sm'} fz={16} ta={'center'}>
									Hours of Operation
								</Title>
								<Group gap={4}>
									<Title fz={18}>Monday-Friday:</Title>
									<Text>9am - 5pm</Text>
								</Group>
								<Group gap={4} c={'dimmed'}>
									<Title fz={18}>Saturday, Sunday:</Title>
									<Text>Closed</Text>
								</Group>
							</Stack>

							<iframe
								title={'Wellview Care Fort Lauderdale'}
								width="100%"
								height="600"
								loading="lazy"
								src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3581.854281213991!2d-80.1540557!3d26.1362938!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9019fa45a1df1%3A0x126224e077d70022!2sWellview%20Care!5e0!3m2!1sen!2sbd!4v1744263315041!5m2!1sen!2sbd"
								style={{ border: 0, borderRadius: 16, marginTop: 16 }}
							/>
						</Stack>
					</Card>
					<Card className={'shadow-2xl md:p-12 p-8'} radius={'lg'}>
						<Stack gap={'sm'}>
							<Stack gap={'sm'}>
								<Title fz={16} ta={'center'}>
									Fort Pierce
								</Title>
								<Text variant={'gray'}>
									<IconMapPin /> 2708 S US Hwy 1,
									<br /> Fort Pierce, FL 34982
								</Text>
								<UnstyledButton c={'gray.6'} mx={'auto'} component={'a'} className={'flex items-center gap-2'} href={'tel:+1 (772)310-4250'}>
									<IconPhone /> (772)310-4250
								</UnstyledButton>
								<UnstyledButton
									className={'flex items-center gap-2'}
									c={'gray.6'}
									mx={'auto'}
									component={'a'}
									href={'mailto:office.fp@wellviewcare.org'}
								>
									<IconAt /> office.fp@wellviewcare.org
								</UnstyledButton>
							</Stack>
							<Stack gap={0} align={'center'}>
								<Title mt={'sm'} fz={16} ta={'center'}>
									Hours of Operation
								</Title>
								<Group gap={4}>
									<Title fz={18}>Monday-Friday:</Title>
									<Text>9am - 5pm</Text>
								</Group>
								<Group gap={4} c={'dimmed'}>
									<Title fz={18}>Saturday, Sunday:</Title>
									<Text>Closed</Text>
								</Group>
							</Stack>
							<iframe
								src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3541.6214267074765!2d-80.3255741!3d27.4187377!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88def10055a387bf%3A0xf071296d65c61c98!2sWellview%20Care!5e0!3m2!1sen!2sbd!4v1744263379566!5m2!1sen!2sbd"
								title={'Wellview Care Fort Pierce'}
								width="100%"
								height="600"
								loading="lazy"
								style={{ border: 0, borderRadius: 16, marginTop: 16 }}
							/>
						</Stack>
					</Card>
					<Card className={'shadow-2xl md:p-12 p-8'} radius={'lg'}>
						<Stack gap={'sm'}>
							<Stack gap={'sm'}>
								<Title fz={16} ta={'center'}>
									Jacksonville
								</Title>
								<Text variant={'gray'}>
									<IconMapPin /> 1128 N Laura St,
									<br />
									Jacksonville, FL 32206, USA
								</Text>
								<UnstyledButton c={'gray.6'} mx={'auto'} component={'a'} className={'flex items-center gap-2'} href={'tel:+1 904-867-7968'}>
									<IconPhone /> 904-867-7968
								</UnstyledButton>
								<UnstyledButton
									className={'flex items-center gap-2'}
									c={'gray.6'}
									mx={'auto'}
									component={'a'}
									href={'mailto:office.jsx@wellviewcare.org'}
								>
									<IconAt /> office.jsx@wellviewcare.org
								</UnstyledButton>
							</Stack>

							<Stack gap={0} align={'center'}>
								<Title mt={'sm'} fz={16} ta={'center'}>
									Hours of Operation
								</Title>
								<Group gap={4}>
									<Title fz={18}>Monday-Friday:</Title>
									<Text>9am - 5pm</Text>
								</Group>
								<Group gap={4} c={'dimmed'}>
									<Title fz={18}>Saturday, Sunday:</Title>
									<Text>Closed</Text>
								</Group>
							</Stack>
							<iframe
								title={'Wellview Care Jacksonville'}
								width="100%"
								height="600"
								loading="lazy"
								src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3443.479043997188!2d-81.6568142!3d30.337332699999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e5b7a3d4ffa477%3A0xd1972bb2e47f05fb!2sWellview%20Care!5e0!3m2!1sen!2sbd!4v1744263186619!5m2!1sen!2sbd"
								style={{ border: 0, borderRadius: 16, marginTop: 16 }}
							/>
						</Stack>
					</Card>
					<Card className={'shadow-2xl md:p-12 p-8'} radius={'lg'}>
						<Stack gap={'sm'}>
							<Stack gap={'sm'}>
								<Title fz={16} ta={'center'}>
									Riviera Beach
								</Title>
								<Text variant={'gray'}>
									<IconMapPin /> 3514 Broadway, <br />
									Riviera Beach, FL 33403
								</Text>
								<UnstyledButton c={'gray.6'} mx={'auto'} component={'a'} className={'flex items-center gap-2'} href={'tel:+1 561-821-4345'}>
									<IconPhone /> 561-821-4345
								</UnstyledButton>
								<UnstyledButton
									className={'flex items-center gap-2'}
									c={'gray.6'}
									mx={'auto'}
									component={'a'}
									href={'mailto:office.rv@wellviewcare.org'}
								>
									<IconAt /> office.rv@wellviewcare.org
								</UnstyledButton>
							</Stack>

							<Stack gap={0} align={'center'}>
								<Title mt={'sm'} fz={16} ta={'center'}>
									Hours of Operation
								</Title>
								<Group gap={4}>
									<Title fz={18}>Monday-Friday:</Title>
									<Text>9am - 5pm</Text>
								</Group>
								<Group gap={4} c={'dimmed'}>
									<Title fz={18}>Saturday, Sunday:</Title>
									<Text>Closed</Text>
								</Group>
							</Stack>
							<iframe
								title={'Wellview Care Riviera'}
								width="100%"
								height="600"
								loading="lazy"
								src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3561.541933143104!2d-80.0533832!3d26.790867700000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d8d540104a1ef7%3A0x66ff04057d88b4f9!2sWellview%20Care!5e0!3m2!1sen!2sbd!4v1744263258941!5m2!1sen!2sbd"
								style={{ border: 0, borderRadius: 16, marginTop: 16 }}
							/>
						</Stack>
					</Card>
				</Box>
			</TwContainer>
		</section>
	)
}
